import React from 'react';
import styles from './amount.module.scss';
import { KoText } from 'packages/typography';
export default function Aamount({data, row}) {
  return (
    <div className={styles.wrapper}>
      <KoText className={styles.payable} text={`${data} ${row?.currency} `} />
      {row.discount && <div className={styles.row}>
        <KoText className={styles.discount} text={`Discount: ${row.discount}%`} />
        <KoText className={styles.subscription} text={`Subscription: ${row.subscriptionAmount}  ${row?.currency}`} />
      </div>}
    </div>
  );
}
